/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState:
    | {
        currentUser?: API.CurrentUser;
        membership?: any;
        siteConfig?: import('./types/site-config').SiteConfig;
      }
    | undefined,
) {
  const { currentUser, membership } = initialState ?? {};
  // VIP5 = MembershipLevel.admin
  const isVip5 = membership?.membership?.level === 'admin';
  // 角色为 admin 的用户
  const isRoleAdmin = currentUser?.access === 'admin';
  const canAdmin = !!(isRoleAdmin || isVip5);
  const showBBS = initialState?.siteConfig?.showTechSupport !== false;
  return {
    canAdmin,
    vip5: canAdmin,
    showBBS,
  };
}
